module.exports = __webpack_public_path__ + "img/pause.c52dc79c.svg";